export default {
	'--color1v1': '#00dede',
	'--color1v2': '#00a0a4',
	'--color1v1Border': '#00a0a4',
	'--color1v2Border': '#027f83',
	'--color1Text': 'black',

	'--color2v1': '#5c6d7e',
	'--color2v2': '#4f5b6b',
	'--color2v1Border': '#788998',
	'--color2v2Border': '#5c6d7e',
	'--color2Text': 'white',

	'--inputColor': '#4f5b6b',
	'--inputText': 'white',

	'--disabledButton': '#e3e8ea',
	'--disabledButtonBorder': '#cad2d7',
	'--disabledButtonText': 'black',

	'--footerbg': 'black',
	'--footerText': 'white',

	'--headerColor': '#393E46',
	'--headerText': 'white',
	'--navButtonBorder': 'white',

	'--backgroundColor': '#222831',
	'--backgroundColorText': 'white'
} as React.CSSProperties;
